import showRtcNotice from "../showRtcNotice";

export default class Trainings {
  show() {
    // showRtcNotice();
  }
}
